module.exports = __webpack_public_path__ + "static/media/world-icon.d9f3d91a.svg";